import { render, staticRenderFns } from "./DataListingBatchActions.vue?vue&type=template&id=896e011e&scoped=true&"
import script from "./DataListingBatchActions.vue?vue&type=script&lang=js&"
export * from "./DataListingBatchActions.vue?vue&type=script&lang=js&"
import style0 from "./DataListingBatchActions.vue?vue&type=style&index=0&id=896e011e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e011e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
